import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import { groupBy, isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import MainCard from 'components/MainCard';
import { useEffect, useState } from 'react';
import useGetImage from 'hooks/useGetImage';
import { Grid, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import comptroller from 'assets/images/comptroller_white.svg';
import editIcon from 'assets/images/table-icons/edit_green.svg';
import COEPictureUploader from 'components/picture-upload/index';
import DetailPageHeader from 'components/header/DetailPageHeader';
import { Button, Col, Flex, Form, Input, Row, Select } from 'antd';
import { useGetCompanyAllMutation } from 'store/features/process/processApi';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import { useActivationHrMasterMutation } from 'store/features/comptroller/comptrollerApi';

const DetailsEmployee = () => {
	const theme = useTheme();
	const state = useLocation();
	const [form] = Form.useForm();
	const navigate = useNavigate();

	const [showModal, setShowModal] = useState(false);
	const [submitData, setSubmitData] = useState(null);
	const [submitForm, setSubmitForm] = useState(false);
	const [fileList, setFileList] = useState([]);
	const [positionNameMap, setPositionNameMap] = useState({});
	const [positionOptions, setPositionOptions] = useState([]);
	const [modalData, setModalData] = useState({
		head: 'Employees',
		action: '',
	});
	const [stateValues, setStateValues] = useState({
		OrgStructureList: [],
		employeeTableList: [],
	});

	const loginUserPositionCode = useSelector((state) => state?.profile?.positionId);

	const userInfo = {
		...state?.state?.userInfo,
		positionCode: state?.state?.userInfo?.positionCode ?? loginUserPositionCode,
	};

	const { employeeTableList } = stateValues;

	const imageInfo = useGetImage(userInfo?.entityCode);

	const [GetCompanyAll, { data: OrgStructureList }] = useGetCompanyAllMutation();
	const [ActivationHrMasterHandle, { data: ActivationHrMasterRes }] = useActivationHrMasterMutation();

	const activateDeactivateHandler = (userInfo) => {
		const payload = {
			...userInfo,
			activationStatus: userInfo?.activationStatus === 'Active' ? 'Inactive' : 'Active',
		};

		setSubmitData(payload);
		setShowModal(true);

		setModalData({
			head: 'Employees',
			action:
				userInfo?.activationStatus === 'W-I-P' || userInfo?.activationStatus === 'Inactive'
					? 'activate this employee'
					: 'deactivate this employee',
		});
	};

	useEffect(() => {
		GetCompanyAll({});
	}, [GetCompanyAll]);

	useEffect(() => {
		if (OrgStructureList) {
			const positionOptionsArr = [];

			// add all vacant position in drop down
			OrgStructureList?.lynOrgStructModelDetailsVacant?.forEach((position) => {
				positionOptionsArr.push({
					code: position.id,
					value: position.id,
					label: position.positionName,
					displayName: position.positionId,
				});
			});

			setPositionNameMap(groupBy(OrgStructureList?.lynOrgStructModelDetailsAll, 'id'));

			// add current user position in drop down
			if (userInfo?.positionCode) {
				const positionOfCurrentUser = OrgStructureList?.lynOrgStructModelDetailsAll?.find((item) => item?.id === userInfo?.positionCode);
				if (positionOfCurrentUser) {
					positionOptionsArr.push({
						code: positionOfCurrentUser?.id,
						value: positionOfCurrentUser?.id,
						label: positionOfCurrentUser?.positionName,
						displayName: positionOfCurrentUser?.positionId,
					});
				}
			}

			setPositionOptions(positionOptionsArr);
		}
		//eslint-disable-next-line
	}, [OrgStructureList, userInfo?.positionCode]);

	useEffect(() => {
		if (state?.state) {
			setStateValues({
				employeeTableList: state?.state?.employeeTableList,
			});
		} else {
			navigate('/static/employee');
		} //eslint-disable-next-line
	}, [state?.state]);

	const initialOptions = [
		{
			value: 'Mr.',
			label: 'Mr.',
		},
		{
			value: 'Ms.',
			label: 'Ms.',
		},
	];

	useEffect(() => {
		if (userInfo && !isEmpty(positionNameMap)) {
			form.setFieldsValue({
				...userInfo,
				positionCode: userInfo?.positionCode ? userInfo?.positionCode : 'No Position Assign',
				designation: positionNameMap?.[userInfo?.positionCode]?.[0]?.positionName ?? 'Not Applicable',
			});
		}
	}, [userInfo, positionNameMap]);

	useEffect(() => {
		if (imageInfo?.image) {
			setFileList(
				imageInfo?.image
					? [
							{
								uid: '-1',
								name: imageInfo.entityFullName,
								status: 'done',
								url: imageInfo.image,
							},
						]
					: []
			);
		}
	}, [imageInfo?.image]);

	useEffect(() => {
		if (ActivationHrMasterRes) {
			if (ActivationHrMasterRes?.status === 'SUCCESS') {
				toast.success('Success! Action completed.', toastConfig);

				state?.state?.tab ? navigate(`/static/employee?tab=${state?.state?.tab}`) : navigate('/static/employee');
			} else if (ActivationHrMasterRes?.status === 'FAILED') {
				toast.error('Failure! Action not completed.', toastConfig);
			}
		}
	}, [ActivationHrMasterRes]);

	useEffect(() => {
		if (submitData) {
			ActivationHrMasterHandle(submitData);

			setSubmitData(null);
		}
	}, [submitForm]);

	return (
		<Grid container rowSpacing={4.5} columnSpacing={2.75}>
			<Grid item xs={12}>
				<DetailPageHeader title="View Employee" />

				<div>
					<MainCard>
						<Form form={form} id="coe-hrorgstructure" layout="vertical" requiredMark={false} disabled>
							<Form.Item name="id" hidden={true}>
								<Input />
							</Form.Item>
							<Form.Item autoComplete="off" style={{ height: '102px' }}>
								<COEPictureUploader fileList={fileList} setFileList={setFileList} />
							</Form.Item>

							<Row gutter={[16, 0]}>
								<Col xs={24} sm={8} md={8} xl={8}>
									<Form.Item
										htmlFor="entityInitials"
										label="Initial"
										name="entityInitials"
										rules={[
											{
												required: true,
												message: 'Initial is required.',
											},
										]}
									>
										<Select
											//
											showSearch
											allowClear
											style={{ width: '100%' }}
											filterOption={true}
											placeholder="Select"
											optionFilterProp="children"
											autoComplete="off"
										>
											{initialOptions.map((value, index) => (
												<Select.Option key={index} id={value?.code} value={value?.value}>
													{value.label}
												</Select.Option>
											))}
										</Select>
									</Form.Item>
								</Col>
							</Row>

							<Row gutter={[16, 0]}>
								{/* <Col xs={24} sm={24} md={24} xl={24}>
                  Name
                </Col> */}
								<Col xs={24} sm={8} md={8} xl={8}>
									<Form.Item label="First Name" htmlFor="entityFirstName" name="entityFirstName" autoComplete="off">
										<Input id="entityFirstName" placeholder="Enter First Name" autoComplete="off" />
									</Form.Item>
								</Col>

								<Col xs={24} sm={8} md={8} xl={8}>
									<Form.Item label="Middle Name" htmlFor="entityMiddleName" name="entityMiddleName" autoComplete="off">
										<Input id="entityMiddleName" placeholder="Enter Middle Name" autoComplete="off" />
									</Form.Item>
								</Col>

								<Col xs={24} sm={8} md={8} xl={8}>
									<Form.Item label="Last Name" htmlFor="entityLastName" name="entityLastName" autoComplete="off">
										<Input id="entityLastName" placeholder="Enter Last Name" autoComplete="off" />
									</Form.Item>
								</Col>
							</Row>

							<Row gutter={[16, 0]}>
								<Col xs={24} sm={12} md={12} xl={12}>
									<Form.Item htmlFor="entityEmail" label="Email" name="entityEmail" autoComplete="off">
										<Input id="entityEmail" placeholder="Enter Email Address" autoComplete="off" />
									</Form.Item>
								</Col>

								<Col xs={24} sm={12} md={12} xl={12}>
									<Form.Item
										htmlFor="entityPhoneNumber"
										label="Mobile"
										name="entityPhoneNumber"
										rules={[
											{
												validator: (_, value) => {
													if (!value) {
														return Promise.reject('Mobile number is required.');
													} else if (/^[0-9]\d{1,14}$/.test(value)) {
														return Promise.resolve();
													} else {
														return Promise.reject('Invalid Mobile number');
													}
												},
											},
										]}
										autoComplete="off"
									>
										<Input id="entityPhoneNumber" placeholder="Enter Phone Number (+880-XXXXXXXXXX)" autoComplete="off" />
									</Form.Item>
								</Col>
							</Row>

							<Row gutter={[16, 0]}>
								<Col xs={24} sm={12} md={12} xl={12}>
									<Form.Item
										htmlFor="positionCode"
										label="Position ID - Name"
										name="positionCode"
										rules={[
											{
												// required: true,
												// message: "Position ID is required.",
											},
										]}
									>
										<Select disabled={true} style={{ width: '100%' }} placeholder="Select From the List" autoComplete="off">
											{positionOptions.map((value, index) => (
												<Select.Option key={index} id={value?.code} value={value?.value}>
													{/* {value.label === "" ? "-" : `${value?.displayName} - ${value.label}`} */}
													{`${value?.displayName} - ${value.label}`}
												</Select.Option>
											))}
										</Select>
									</Form.Item>
								</Col>

								<Col xs={24} sm={12} md={12} xl={12}>
									<Form.Item
										htmlFor="designation"
										label="Designation"
										name="designation"
										// rules={[
										//   {
										//     required: true,
										//     validator: validateInput,
										//   },
										// ]}
										autoComplete="off"
									>
										<Input disabled id="designation" placeholder="System generated" autoComplete="off" />
									</Form.Item>
								</Col>

								<Col xs={24} sm={12} md={12} xl={12}>
									<Form.Item htmlFor="jobBand" label="Job Band" name="jobBand" autoComplete="off">
										<Input id="jobBand" placeholder="Select from the List" autoComplete="off" />
									</Form.Item>
								</Col>

								<Col xs={24} sm={12} md={12} xl={12}>
									<Form.Item htmlFor="payGrade" label="Pay Grade" name="payGrade" autoComplete="off">
										<Input id="payGrade" placeholder="Select from the List" autoComplete="off" />
									</Form.Item>
								</Col>
							</Row>

							<Row gutter={[16, 0]}>
								<Col xs={24}>
									<Form.Item
										htmlFor="employeeId"
										label="Employee Id"
										name="employeeId"
										// rules={[
										//   {
										//     required: true,
										//     validator: validateInput,
										//   },
										// ]}
										autoComplete="off"
									>
										<Input disabled id="employeeId" placeholder="System generated" autoComplete="off" />
									</Form.Item>
								</Col>
							</Row>

							<Row gutter={[16, 0]}>
								<Col xs={24}>
									<Form.Item
										htmlFor="activationStatus"
										label="Activation Status"
										name="activationStatus"
										// rules={[
										//   {
										//     required: true,
										//     validator: validateInput,
										//   },
										// ]}
										autoComplete="off"
									>
										<Input disabled id="activationStatus" placeholder="Activation status" autoComplete="off" />
									</Form.Item>
								</Col>
							</Row>
						</Form>

						{/* <Flex style={{ marginTop: "10px" }} justify="flex-end" align="flex-end">
              <Button
                style={{ margin: "1px" }}
                icon={<img src={editIcon} width={16} height={16} alt="edit" />}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate("/static/employee/edit", { state: { userInfo, OrgStructureList, employeeTableList } });
                }}
              >
                Edit
              </Button>
            </Flex> */}

						<Flex style={{ marginTop: '10px' }} justify="flex-end" align="flex-end">
							<Tooltip title={userInfo?.activationStatus === 'Active' ? 'Deactivate' : 'Activate'}>
								<Button
									type="primary"
									style={{
										margin: '3px',
										backgroundColor:
											userInfo?.activationStatus === 'Active' ? theme.palette.lynTheme.delete : theme.palette.lynTheme.success,
									}}
									onClick={(e) => {
										e.stopPropagation();

										activateDeactivateHandler(userInfo);
									}}
								>
									{userInfo?.activationStatus === 'Active' ? 'Deactivate' : 'Activate'}
								</Button>
							</Tooltip>

							<Tooltip title="Edit">
								<Button
									style={{ margin: '1px' }}
									icon={<img src={editIcon} width={16} height={16} alt="edit" />}
									onClick={(e) => {
										e.stopPropagation();
										navigate('/static/employee/edit', { state: { userInfo, OrgStructureList, employeeTableList } });
									}}
								>
									Edit
								</Button>
							</Tooltip>
						</Flex>
					</MainCard>

					{showModal && (
						<ComptrollerConfirmModal
							showModal={showModal}
							setShowModal={setShowModal}
							setSubmitForm={setSubmitForm}
							modalData={modalData}
						/>
					)}
				</div>
			</Grid>
		</Grid>
	);
};

export default DetailsEmployee;
